/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsText: {
  name: 'text';
  data: string;
} = {
  name: 'text',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.646.646A.5.5 0 0 1 1 .5h14a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V1.5h-6v13H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h2.5v-13h-6V3a.5.5 0 0 1-1 0V1A.5.5 0 0 1 .646.646Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
